import type { ProductVisualPublishedImage } from "@nova-ai/shared"

import { StatusBadge } from "../ui/status-badge"

type TemplateVersionPair = Pick<
  ProductVisualPublishedImage,
  "templateVersion" | "currentTemplateVersion"
>

/** One template-freshness definition for product cells and Studio review cards. */
export function ProductVisualTemplateFreshnessBadge({ image }: { image: TemplateVersionPair }) {
  if (image.templateVersion === image.currentTemplateVersion) {
    return (
      <StatusBadge tone="success" className="max-w-full whitespace-normal text-center">
        Template current
      </StatusBadge>
    )
  }
  if (image.templateVersion < image.currentTemplateVersion) {
    const staleLabel = `Template stale · v${image.templateVersion} → v${image.currentTemplateVersion}`
    return (
      <StatusBadge tone="warning" className="max-w-full whitespace-normal text-center">
        {staleLabel}
      </StatusBadge>
    )
  }
  const mismatchLabel = `Template mismatch · image v${image.templateVersion} / app v${image.currentTemplateVersion}`
  return (
    <StatusBadge tone="warning" className="max-w-full whitespace-normal text-center">
      {mismatchLabel}
    </StatusBadge>
  )
}
